import axios from "axios";
import tokenManager from "../security/tokenManager";
import { installClientDiagnosticsBuffer } from "./clientDiagnosticsBuffer";
import { extractClientErrorMessage } from "./buildSupportErrorReport";
import { rememberReportableError } from "./sanitizeErrorForReport";
import { offerSupportErrorReport } from "./supportErrorReportEvents";

function isLoginOrPublicRoute() {
  if (typeof window === "undefined") return true;
  const path = window.location.pathname || "";
  if (path === "/login" || path.startsWith("/login/")) return true;
  if (path === "/anmalning" || path.startsWith("/anmalning/")) return true;
  if (path === "/data-deletion" || path.startsWith("/data-deletion/")) return true;
  return false;
}

/** Uncaught non-API failures (validation, etc.) while logged in. */
export function installClientSideSupportErrorReporting() {
  if (typeof window === "undefined" || window.__neweraClientSupportErrorsInstalled) return;
  window.__neweraClientSupportErrorsInstalled = true;

  installClientDiagnosticsBuffer();

  window.addEventListener("unhandledrejection", (event) => {
    if (!tokenManager.getToken() || isLoginOrPublicRoute()) return;
    const reason = event.reason;
    if (axios.isAxiosError(reason)) return;

    rememberReportableError(reason);

    const page = window.__NEWERA_SELECTED_PAGE__ || "";
    const userMessage = extractClientErrorMessage(reason) || "Something went wrong.";
    offerSupportErrorReport({
      page,
      action: "unhandledPromiseRejection",
      userMessage,
      error: reason,
      context: { type: typeof reason },
    });
  });
}

/**
 * Call from catch blocks when failure is not tied to axios (or axios used skipSupportErrorReport).
 */
export function offerSupportErrorReportForClientFailure({
  page,
  action,
  userMessage,
  error,
  context,
}) {
  if (!tokenManager.getToken() || isLoginOrPublicRoute()) return;
  rememberReportableError(error);
  offerSupportErrorReport({
    page: page || window.__NEWERA_SELECTED_PAGE__ || "",
    action,
    userMessage,
    error,
    context,
  });
}
